import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { UpdateLoaderVisibility } from '../store/actions/loader.actions';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(private store: Store<any>) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        this.store.dispatch(new UpdateLoaderVisibility(1));
        return next.handle(req).pipe(
            this.onCancelled(() => {
                // cancelled request callback
            }),
            tap(
                event => {
                    if (event instanceof HttpResponse) {
                        this.store.dispatch(new UpdateLoaderVisibility(-1));
                    }
                },
                error => {
                    this.store.dispatch(new UpdateLoaderVisibility(-1));
                }
            )
        );
    }

    onCancelled<T>(callback: () => void) {
        return (obs: Observable<T>) => {
            let cancelled = true;
            return new Observable<T>(subscriber => {
                const sub = obs.subscribe(
                    value => {
                        if (value instanceof HttpResponse) { cancelled = false };
                        subscriber.next(value);
                    },
                    err => {
                        cancelled = false;
                        subscriber.error(err);
                    },
                    () => {
                        cancelled = false;
                        subscriber.complete();
                    });
                return () => {
                    if (cancelled) {
                        this.store.dispatch(new UpdateLoaderVisibility(-1));
                    }
                    sub.unsubscribe();
                };
            });
        };
    }
}
